import { Map, List } from 'immutable'

/**
 * Build POST body to create a duplicate page-manager section from Redux state.
 * Uses persisted section fields plus tempVisibility when visibility rules were edited.
 *
 * @param {import('immutable').Map} pmSection Section from pmSection.sections
 * @returns {Object} Plain object for createSection API
 */
export function buildDuplicateSectionCreatePayload (pmSection) {
  if (!pmSection || !Map.isMap(pmSection)) {
    throw new Error('pmSection must be an Immutable Map')
  }

  const adminTitle = pmSection.get('adminTitle', '') || ''
  const duplicateAdminTitle = adminTitle.trim() ? `${adminTitle} (Copy)` : '(Copy)'

  let visibility = pmSection.get('visibility', List())
  const tempVisibility = pmSection.get('tempVisibility')
  if (tempVisibility) {
    visibility = tempVisibility
  }

  return pmSection
    .delete('id')
    .delete('sectionId')
    .delete('createdAt')
    .delete('updatedAt')
    .delete('updatedBy')
    .delete('tempVisibility')
    .set('adminTitle', duplicateAdminTitle)
    .set('visibility', visibility)
    .set('enabled', false)
    .toJS()
}
